<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="time-bar">
        <div class="time-inner text-left text-white">
          <p class="col-12">
            <span class="active">本页内容</span>
            <span>公司简介</span>
            <span @click="slideToValue()" style="cursor:pointer;">企业文化</span>
          </p>
        </div>
      </div>

      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">公司简介</span></p>
      </div>

      <div class="part row">
        <div class="col-md-6 col-12 part-left">
          <p class="text-left title">上海嘉定及时雨</p>
          <p class="text-left title">小额贷款股份有限公司</p>
          <p class="text-left p2">公司于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。</p>
          <p class="text-left p2">公司拥有一支深耕小微金融近20年的核心团队，坚持小而分散的信贷理念，通过数字化、数据化、信息化打造小微金融的全流程智能风控系统“慧石系统”，服务于机构及小微企业客户。</p>
          <p class="text-left p3">公司成立六年来已累计为11095户用户发放贷款87.53亿元，不良率最高为千分之九，在行业内属于龙头企业。并连续多年被评为中国百强小贷公司及上海市金融监管A类小贷公司。</p>
        </div>
        <div class="col-md-6 col-12 part-right">
          <img src="../img/about-us/right.png" width="100%" alt="">
        </div>
      </div>

      <div class="target">
        <div class="row">
          <div class="col-4">
            <p class="title">使命</p>
            <p class="subtitle1">科技让小微</p>
            <p class="subtitle">金融更简单</p>
          </div>
          <div class="col-4">
            <p class="title">精神</p>
            <p class="subtitle1">激流勇进</p>
            <p class="subtitle">滴水穿石</p>
          </div>
          <div class="col-4">
            <p class="title">作风</p>
            <p class="subtitle1">雷厉风行</p>
            <p class="subtitle">精益求精</p>

          </div>
        </div>
      </div>

      <div class="value" id="value">
        <!--<img src="../img/about-us/bottom.png" width="100%" alt="">-->
        <div class="value-block">
          <p class="title text-left">价值观</p>
          <p class="desc">诚信：诚实正直，信守承诺</p>
          <p class="desc">团队：互信合作，大局为重</p>
          <p class="desc">创新：不断改进，包容失败</p>
          <p class="desc">激情：只做第一，永不言弃</p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header'
  import Footer from './Footer'
  import $ from 'jquery'

  export default {
    name: "about-us",
    components:{Header,Footer},
    methods:{
      slideToValue: function() {
        $('html,body').animate({
            scrollTop: $('#value').offset().top
          },
          350);
      },
    }
  }
</script>

<style scoped lang="less">
  @gray-35383D:#35383D;
  @gray-A2A4A8:#A2A4A8;
  @fs56:56px;

  p{margin:0;}
  //pc、laptop
  @media screen and (min-width: 769px) {
    .time-inner,.top,.part,.target .row{
      width:1300px !important;
    }
    .value{
      background:url('../img/about-us/bottom.png') no-repeat center center;
      .value-block{
        color:#fff;
        right:25%;
      }
    }
    .p2{
      line-height:26px;
    }
    .p3{
      line-height:26px;
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
      font-size: 26px;
    }
    .part-left{
      margin-bottom:100px;
    }
    .part{
      .p2,.p3{
        width:90% !important;
        line-height:50px;

      }
    }
    .value{
      background:url('../img/about-us/bottom.png') no-repeat left center;
      .value-block{
        color:#000;
        right:8%;
      }
    }
  }

  .time-bar{
    height:90px;
    background:#01A494;
    .time-inner{
      height:90px;
      line-height:90px;
      margin:0 auto;
      font-size:20px;
      padding-left:50px;
      span{
        margin-right:38px;
        &.active{
          opacity:.6;
        }
      }
    }
  }

  .top{
    margin: 60px auto 48px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }

    .title{
      /*color:#35383D;*/
      font-size:56px;
      margin-bottom:15px;
      font-weight:800;
    }
    .subtitle{
      font-size:20px;
      color:#696D71;
    }
  }

  .part{
    /*width:70%;*/
    margin:0 auto 92px;
    /*height:713px;*/
    background:#fff;
    padding-left:50px;

    .title{
      color:@gray-35383D;
      font-size:40px;
      font-weight:bold;
      margin-bottom:50px;

      &:first-child{
        margin-bottom:0;
      }
    }
    .p2{
      width:500px;
      color:#2c3e50;
      margin-bottom:41px;
    }
    .p3{
      width:500px;
      color:#2c3e50;
    }

    .part2-text{
      position:absolute;
      bottom:96px;
      width:72%;
      min-width:855px;
      padding-left:50px;
      height:177px;
      background:#fff;
      padding-top:34px;
      box-shadow: 0 8px 30px 2px #eee;

      .biggest{
        font-size:@fs56;
        margin-bottom:0;
      }
      .bigger{
        font-size:33px;
        vertical-align: 4px
      }
      .subtitle{
        color:#737679;
        padding-left: 10px;
      }
    }
  }

  .target{
    background:#F7F7F7;
    .row{
      margin:0 auto;
      /*height:320px;*/
      padding-top:131px;

      .title{
        font-size:32px;
        margin-bottom:35px;
        font-weight:bold;
      }
      .subtitle{
        margin-bottom:82px;
      }

    }
  }

  .value{
    position:relative;
    height:662px;
    background-size:cover;
    .value-block{
      position:absolute;
      top:30%;
      .title{
        font-size:40px;
        margin-bottom:35px;
      }
      .desc{
        font-size:22px;
        margin-bottom:10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/about-us.vue